import React from 'react';
import './Privacy&policy.css';
import { Fade, Slide } from 'react-awesome-reveal';

const TalentTrekPrivacyPolicy = () => {
  return (
    <div className="talent-privacy-container container py-5">
      <Fade direction="down" triggerOnce>
        <h1 className="talent-privacy-title text-center mb-3">Privacy Policy for Talent Trek Technologies</h1>
        <p className="talent-privacy-updated text-center mb-5">Last Updated: June 23, 2025</p>
      </Fade>

      {policySections.map((section, index) => (
        <Slide
          direction={index % 2 === 0 ? 'left' : 'right'}
          triggerOnce
          key={index}
        >
          <div className="talent-privacy-section mb-4">
            <h4 className="talent-privacy-section-title">{section.title}</h4>
            <div className="talent-privacy-section-content">{section.content}</div>
          </div>
        </Slide>
      ))}
    </div>
  );
};

export default TalentTrekPrivacyPolicy;

const policySections = [
  {
    title: '1. Definitions',
    content: (
      <ul>
        <li><strong>Personal Information (PI):</strong> Any information that relates to an individual, which, alone or in combination with other information, can identify that individual.</li>
        <li><strong>Sensitive Personal Data or Information (SPDI):</strong> Includes passwords, financial details, biometric data, medical records.</li>
        <li><strong>Data Principal:</strong> You, the individual user.</li>
        <li><strong>Data Fiduciary:</strong> Talent Trek Technologies.</li>
      </ul>
    )
  },
  {
    title: '2. Types of Information Collected',
    content: (
      <>
        <p>We may collect the following types of information:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email, phone number, company name, IP address, etc.</li>
          <li><strong>SPDI:</strong> Bank details, login credentials, biometric data (with consent).</li>
          <li><strong>Other Info:</strong> Form data, feedback, usage statistics, cookies.</li>
        </ul>
      </>
    )
  },
  {
    title: '3. Purpose of Collection and Use',
    content: (
      <ul>
        <li>To deliver IT services including consulting, software development, cybersecurity.</li>
        <li>To improve services and website experience.</li>
        <li>For legal compliance and analytics.</li>
        <li>To send promotional materials (with your consent).</li>
      </ul>
    )
  },
  {
    title: '4. Consent',
    content: (
      <ul>
        <li><strong>Notice & Choice:</strong> You are informed before we collect your data.</li>
        <li><strong>Explicit Consent:</strong> SPDI collection requires clear consent.</li>
        <li><strong>Withdraw Consent:</strong> You may withdraw anytime via Section 12 contact.</li>
      </ul>
    )
  },
  {
    title: '5. Disclosure of Information',
    content: (
      <ul>
        <li>To service providers, affiliates (with consent), or authorities as legally required.</li>
        <li>No selling of personal data.</li>
        <li>Transfers comply with DPDPA, 2023.</li>
      </ul>
    )
  },
  {
    title: '6. Security Practices',
    content: (
      <ul>
        <li>SSL encryption, secure storage, access restrictions.</li>
        <li>Routine audits and breach notifications.</li>
        <li>Compliance with IT Act and SPDI Rules.</li>
      </ul>
    )
  },
  {
    title: '7. Data Retention',
    content: <p>Data is retained only as long as needed for legal or service purposes, then deleted securely.</p>
  },
  {
    title: '8. Cookies and Tracking Technologies',
    content: <p>Cookies enhance experience. Includes session, persistent, and analytics cookies. You may control them via browser settings.</p>
  },
  {
    title: '9. Your Rights',
    content: (
      <ul>
        <li>Access, correct, or erase your data.</li>
        <li>Restrict or withdraw consent.</li>
        <li>File complaints via Section 11 grievance process.</li>
      </ul>
    )
  },
  {
    title: '10. Third-Party Links',
    content: <p>We’re not responsible for external site practices. Review their privacy policies separately.</p>
  },
  {
    title: '11. Grievance Officer',
    content: (
      <p>
        Name: Glory H<br />
        Email: grievance@talenttrektechnologies.com<br />
        Address: 4th Floor, Novel MSR, Marathahalli, Bangalore, Karnataka.
      </p>
    )
  },
  {
    title: '12. Contact Us',
    content: (
      <p>
        Email: contactus@talenttrektechnologies.com<br />
        Phone: 9492410014<br />
        Address: 4th Floor, Novel MSR, Marathahalli, Bangalore, Karnataka.
      </p>
    )
  },
  {
    title: '13. Updates to This Policy',
    content: <p>Policy may be updated. Continued use implies agreement with updates posted on our website.</p>
  },
  {
    title: '14. Governing Law',
    content: <p>This policy is governed by Indian law. Bengaluru courts have exclusive jurisdiction.</p>
  }
];
